import React from 'react';
import { IconType, IconBaseProps } from 'react-icons';

export type KpiCardProps = {
  label: string;
  value: string | number;
  icon: IconType;
  accent?: 'brand' | 'red' | 'green' | 'yellow' | 'indigo' | 'amber' | 'sedra';
  'data-kpi'?: string;
  tabIndex?: number;
  role?: string;
};

const ACCENT_MAP: Record<string, string> = {
  sedra: 'before:bg-sedra',
  brand: 'before:bg-brand',
  red: 'before:bg-red-600',
  green: 'before:bg-green-600',
  yellow: 'before:bg-yellow-400',
  indigo: 'before:bg-indigo-500',
  amber: 'before:bg-amber-500',
};

export const KpiCard: React.FC<KpiCardProps> = ({
  label,
  value,
  icon,
  accent = 'brand',
  tabIndex,
  role,
  'data-kpi': dataKpi,
}) => {
  const IconComponent = icon as React.ComponentType<IconBaseProps>;
  return (
    <div
      className={`relative rounded-2xl border border-gray-200 bg-white p-5 elev-1 before:absolute before:inset-y-0 before:left-0 before:w-1.5 before:rounded-l-2xl ${ACCENT_MAP[accent]} hover:shadow-md transition-shadow focus:outline-none focus-visible:ring-2 focus-visible:ring-sedra focus-visible:ring-offset-2 dark:bg-neutral-900 dark:border-neutral-800`}
      tabIndex={tabIndex}
      role={role}
      data-kpi={dataKpi}
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}</div>
          <div className="mt-1 text-2xl font-extrabold text-gray-900 dark:text-white">{value}</div>
        </div>
        <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-sedra/10 text-sedra dark:bg-sedra/20 dark:text-sedra">
          <IconComponent size={20} aria-hidden="true" />
        </span>
      </div>
    </div>
  );
}; 